/**
 * [2026-11-05] 상점주 판매현황 — 쿠폰 사용 표시 공용 함수 (웹 giftSales.js · 앱 Status.js 판매 탭).
 *
 * 백엔드(GET gift/salesStatus/:storeNo)가 행마다 내려줄 값:
 *   listPrice          정가(gift.price) — price 는 쿠폰 적용 후 실결제액
 *   couponDiscountAmt  이 구매의 쿠폰 할인 합계
 *   coupons            [{ promotionNo, name, issuerType, discountAmt }] — 한 구매에 2장 이상일 수 있다
 * 합계(list[1][0]):
 *   totalCouponDiscountAmount
 *
 * ★백엔드 반영 전에는 위 값이 응답에 없다 → hasCouponSales() 가 false 라 쿠폰 열·합계 줄을 숨긴다.
 */

const BURDEN_LABEL = {
  ko: { STORE: '상점 부담', CHANNEL: '채널 부담', PLATFORM: '내기프트 부담' },
  en: { STORE: 'Store', CHANNEL: 'Channel', PLATFORM: 'Naegift' },
};

/** 응답에 쿠폰 필드가 있는지(백엔드 반영 여부) */
export function hasCouponSales(rows, summary) {
  if (summary && summary.totalCouponDiscountAmount != null) return true;
  return Array.isArray(rows) && rows.some(r => r && ('coupons' in r || 'couponDiscountAmt' in r));
}

/** 발행처 → 부담 주체 라벨. 모르는 값이면 빈 문자열 */
export function couponBurdenLabel(issuerType, language = 'ko') {
  const map = BURDEN_LABEL[language] || BURDEN_LABEL.ko;
  return map[issuerType] || '';
}

/**
 * 한 판매 건의 쿠폰 줄 목록.
 *  coupons 가 있으면 그대로, 없는데 할인액만 있으면(연결 끊긴 옛 건) 이름 없이 한 줄.
 *  쿠폰을 안 썼으면 [].
 */
export function couponLinesOf(item, language = 'ko') {
  const list = Array.isArray(item?.coupons) ? item.coupons : [];
  if (list.length > 0) {
    return list.map(c => ({
      key: c.promotionNo ?? c.name,
      name: c.name || (language === 'ko' ? '쿠폰' : 'Coupon'),
      amount: Number(c.discountAmt || 0),
      burden: couponBurdenLabel(c.issuerType, language),
    }));
  }
  const total = Number(item?.couponDiscountAmt || 0);
  if (total > 0) {
    return [{ key: 'total', name: language === 'ko' ? '쿠폰' : 'Coupon', amount: total, burden: '' }];
  }
  return [];
}
